// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://explorer.inkonchain.com/address/0x4172E6aAEC070ACB31aaCE343A58c93E4C70f44D
export const POOL_ADDRESSES_PROVIDER = '0x4172E6aAEC070ACB31aaCE343A58c93E4C70f44D';

// IPool https://explorer.inkonchain.com/address/0x2816cf15F6d2A220E789aA011D5EE4eB6c47FEbA
export const POOL = '0x2816cf15F6d2A220E789aA011D5EE4eB6c47FEbA';

// IPoolConfigurator https://explorer.inkonchain.com/address/0x4f221e5c0B7103f7e3291E10097de6D9e3BfC02d
export const POOL_CONFIGURATOR = '0x4f221e5c0B7103f7e3291E10097de6D9e3BfC02d';

// IAaveOracle https://explorer.inkonchain.com/address/0x4758213271BFdC72224A7a8742dC865fC97756e1
export const ORACLE = '0x4758213271BFdC72224A7a8742dC865fC97756e1';

// https://explorer.inkonchain.com/address/0x1dF462e2712496373A347f8ad10802a5E95f053D
export const ACL_ADMIN = '0x1dF462e2712496373A347f8ad10802a5E95f053D';

// IACLManager https://explorer.inkonchain.com/address/0x86E2938daE289763D4e09a7e42c5cCcA62Cf9809
export const ACL_MANAGER = '0x86E2938daE289763D4e09a7e42c5cCcA62Cf9809';

// IPoolDataProvider https://explorer.inkonchain.com/address/0x96086C25d13943C80Ff9a19791a40Df6aFC08328
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x96086C25d13943C80Ff9a19791a40Df6aFC08328';

// https://explorer.inkonchain.com/address/0x7F6036c2A9244E766F9CcD8dE78D8f79F80e5408
export const POOL_IMPL = '0x7F6036c2A9244E766F9CcD8dE78D8f79F80e5408';

// https://explorer.inkonchain.com/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://explorer.inkonchain.com/address/0xD93e3Ae8f69D04d484d1652Ca569d4b0522414DF
export const DEFAULT_INCENTIVES_CONTROLLER = '0xD93e3Ae8f69D04d484d1652Ca569d4b0522414DF';

// https://explorer.inkonchain.com/address/0x9CbcEf2c44cF28ff2aa36Bff7BaB315398209A79
export const EMISSION_MANAGER = '0x9CbcEf2c44cF28ff2aa36Bff7BaB315398209A79';

// ICollector https://explorer.inkonchain.com/address/0x9138E2cAdFEB23AFFdc0419F2912CaB8F135dba9
export const COLLECTOR = '0x9138E2cAdFEB23AFFdc0419F2912CaB8F135dba9';

// https://explorer.inkonchain.com/address/0xb322B2B3cDDEBA3c726A8d0306A86697DE3ECcFf
export const DEFAULT_A_TOKEN_IMPL = '0xb322B2B3cDDEBA3c726A8d0306A86697DE3ECcFf';

// https://explorer.inkonchain.com/address/0xED9ee9CEC2782a307E8F6ca6E10977B4Ad44358D
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xED9ee9CEC2782a307E8F6ca6E10977B4Ad44358D';

// https://explorer.inkonchain.com/address/0x988B5d3863bdEE83339Be41cD31344Dfd9FD197c
export const L2_ENCODER = '0x988B5d3863bdEE83339Be41cD31344Dfd9FD197c';

// https://explorer.inkonchain.com/address/0xb04280b09F47cFd81906817505F24ceFE1BA86D2
export const CONFIG_ENGINE = '0xb04280b09F47cFd81906817505F24ceFE1BA86D2';

// https://explorer.inkonchain.com/address/0x2F9fDD0D80843b21A7e2c7bfe2A6278231A5683e
export const RISK_STEWARD = '0x2F9fDD0D80843b21A7e2c7bfe2A6278231A5683e';

// https://explorer.inkonchain.com/address/0x501B4c19dd9C2e06E94dA7b6D5Ed4ddA013EC741
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x501B4c19dd9C2e06E94dA7b6D5Ed4ddA013EC741';

// https://explorer.inkonchain.com/address/0x25Ec457d1778b0E5316e7f38f3c22baF413F1A8C
export const UI_INCENTIVE_DATA_PROVIDER = '0x25Ec457d1778b0E5316e7f38f3c22baF413F1A8C';

// https://explorer.inkonchain.com/address/0xF1485fb7DBFa5db0B368FeA808FD6ff945c36064
export const UI_POOL_DATA_PROVIDER = '0xF1485fb7DBFa5db0B368FeA808FD6ff945c36064';

// https://explorer.inkonchain.com/address/0xB1532b76D054c9F9E61b25c4d91f69B4133E4671
export const WALLET_BALANCE_PROVIDER = '0xB1532b76D054c9F9E61b25c4d91f69B4133E4671';

// https://explorer.inkonchain.com/address/0xDe090EfCD6ef4b86792e2D84E55a5fa8d49D25D2
export const WETH_GATEWAY = '0xDe090EfCD6ef4b86792e2D84E55a5fa8d49D25D2';

// https://explorer.inkonchain.com/address/0xb50881a9e7Ca0d1c08A59f4da1dE2f3D75B1E34E
export const DUST_BIN = '0xb50881a9e7Ca0d1c08A59f4da1dE2f3D75B1E34E';

// https://explorer.inkonchain.com/address/0x5362dBb1e601abF3a4c14c22ffEdA64042E5eAA3
export const STATA_FACTORY = '0x5362dBb1e601abF3a4c14c22ffEdA64042E5eAA3';

export const CHAIN_ID = 57073;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x4200000000000000000000000000000000000006',
    A_TOKEN: '0x2B35eF056728BaFFaC103e3b81cB029788006EF9',
    V_TOKEN: '0xc1457AcfBaD2332b07B7651A4Da3176E8F3Bc9E4',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x163131609562E578754aF12E998635BfCa56712C',
  },
  kBTC: {
    decimals: 8,
    id: 1,
    UNDERLYING: '0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98',
    A_TOKEN: '0xC712C3a5624de08EA593FB23270804B47942564e',
    V_TOKEN: '0x47D9b89775958F0b5c7734C5570565Ce575e7e94',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0xAe48F22903d43f13f66Cc650F57Bd4654ac222cb',
  },
  USDT: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0x0200C29006150606B650577BBE7B6248F58470c1',
    A_TOKEN: '0x99cBF1Ff4527675Ed3301671105C9F7748fb8a04',
    V_TOKEN: '0xA5d61eF3D06234371507e54FB709F401E590719a',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x24FdD142b34C6B5D55299709DB0966681933c9aF',
  },
  USDG: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xe343167631d89B6Ffc58B88d6b7fB0228795491D',
    A_TOKEN: '0x4cd13ce4edbB5523fd4849252b5f1bF215129D10',
    V_TOKEN: '0x08443163427BaE789774f45198315f6EAefe566C',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x38758C93672A9F3F4297016BE4Ac1aCA70DcE82A',
  },
  GHO: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73',
    A_TOKEN: '0xC629140A8aA21F8f319A21F41b2DC1b0431693C1',
    V_TOKEN: '0x45b30e3F687EEC15702dff29069f24173cB69Af4',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x20fd5f3FCac8883a3A0A2bBcD658A2d2c6EFa6B6',
  },
  USDC: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0x2D270e6886d130D724215A266106e6832161EAEd',
    A_TOKEN: '0x70A38B0c90441e991346B7A0Cd98C8528dD1c234',
    V_TOKEN: '0x305c03f74DBb8C6052b7667AaBEE21dC7c1f0B29',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0xd910061259A256B99654Cff414c3bfD503E7F6ea',
  },
  weETH: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xA3D68b74bF0528fdD07263c60d6488749044914b',
    A_TOKEN: '0x7789888E302Bc3288A78a182efe6DfE91da756ec',
    V_TOKEN: '0xF498bfc4439e91042EeDB9736767F770F48Da474',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x68B7Ed7Df658Ed065BcaA415f0Ce0b057Dfcf318',
  },
  wrsETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x9f0a74A92287E323Eb95c1cd9eCdBEb0e397cAe4',
    A_TOKEN: '0x98F6A9b82799813447E6c00E51aF5b325976199A',
    V_TOKEN: '0x33d3F390F266A21b0467efD559DC5fecD17Db52C',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x771a1668f973f2485D32580aB53F5C4934e81531',
  },
  ezETH: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x2416092f143378750bb29b79eD961ab195CcEea5',
    A_TOKEN: '0xd596B3C15E28795AaBF0481DaA0Ff4eBAa42c5F2',
    V_TOKEN: '0x522e93245C2df28904B86103af69bC27ae80FA46',
    INTEREST_RATE_STRATEGY: '0xCFDAdA7DCd2e785cF706BaDBC2B8Af5084d595e9',
    ORACLE: '0x51e5242698Cf425A558BCe440357Fd20f00D9671',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'weETH,wrsETH,ezETH / WETH',
    collateralBitmap: '448',
    collateralAssets: [
      '0xA3D68b74bF0528fdD07263c60d6488749044914b',
      '0x9f0a74A92287E323Eb95c1cd9eCdBEb0e397cAe4',
      '0x2416092f143378750bb29b79eD961ab195CcEea5',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0x4200000000000000000000000000000000000006'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
